var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseXlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34342 24.5912L24.0879 8.84671",
    stroke: "#FDFDFD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34342 8.84439L24.0879 24.5888",
    stroke: "#FDFDFD",
    strokeWidth: 1.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXlIcon);
export default __webpack_public_path__ + "static/media/CloseXLIcon.e77f99d074a4c7f57f4a2f2ca737652d.svg";
export { ForwardRef as ReactComponent };